import { useState, useEffect } from 'react';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';

import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  Typography
} from '@material-ui/core';

//Redux
import { useSelector, useDispatch } from "react-redux";
import { uploadUserImage } from 'src/redux/actions/user.actions';



const useStyles = makeStyles((theme) => ({
 
  input: {
    display: 'none',
  },
}));

const AccountProfile = (props) => { 
  const classes = useStyles();
  const dispatch = useDispatch();
  const [values, setValues] = useState({});

  const { user, isLoggedIn } = useSelector((state) => state.auth);

  const handleUpload = async e => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    dispatch(uploadUserImage(formData))
    .then(() => {
    })
    .catch(err => {
    })

  };



  useEffect(() => {
    if(isLoggedIn && user){
      setValues(user); 
    }
  }, [user])
  
  return (
    <>
    <input
        accept="image/*"
        className={classes.input}
        onChange={handleUpload}
        id="profile-button-file"
        multiple
        type="file"
      />
  <Card {...props}>
    <CardContent>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Avatar
          src={values.dpUrl ? values.dpUrl : '/static/noImg.png'}
          sx={{
            height: 150,
            width: 150
          }}
          className="mb-3"
        />
        <Typography
          color="textPrimary"
          gutterBottom
          variant="h3"
        >
          {`${values.firstName} ${values.lastName}`} 
        </Typography>
        <Typography
          color="textSecondary"
          variant="body1"
        >
        {values.email}
        </Typography>
        <Typography
          color="textSecondary"
          variant="body1"
        >
          {values.phone}
        </Typography>
        <Typography
          color="textSecondary"
          variant="body1"
        >
          {values.position}
        </Typography>
      </Box>
    </CardContent>
    <Divider />
    <label className="col p-0" htmlFor="profile-button-file">
    <CardActions>
        <Button
        color="primary"
        fullWidth
        variant="text"
        component="span"
        className="pb-0"
      >
        Upload picture
      </Button>
    </CardActions>
    </label>
  </Card>
  </>
)
};

export default AccountProfile;
